import React from 'react';
import IconBase from './Icon-base';
export default class Close extends React.Component {
    render() {
        return (
            <IconBase width="30" height="27" viewBox="0 0 30 27" {...this.props}>
                <g xmlns="http://www.w3.org/2000/svg">
                    <path
                        id="path0_fill"
                        fillRule="evenodd"
                        d="M 19.2857 5.35714L 8.57143 5.35714L 8.57143 0L 0 6.07143L 8.57143 12.1429L 8.57143 6.69643L 19.2857 6.69643C 24.455 6.69643 28.6607 10.9021 28.6607 16.0714C 28.6607 21.2407 24.455 25.4464 19.2857 25.4464L 8.42857 25.4464L 8.42857 26.7857L 19.2857 26.7857C 25.2029 26.7857 30 21.9886 30 16.0714C 30 10.1543 25.2029 5.35714 19.2857 5.35714Z"
                    />
                </g>
            </IconBase>
        );
    }
}



// WEBPACK FOOTER //
// ./src/containers/PrivateArea/DocumentViewer/src/SVGIcons/Undo.js